import { Component, OnInit, Input } from '@angular/core';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';

@Component({
  selector: 'app-order-status-icon',
  templateUrl: './order-status-icon.component.html',
  styleUrls: ['./order-status-icon.component.css']
})
export class OrderStatusIconComponent implements OnInit {
  @Input() orderStatus: OrderStatusObject;

  constructor() { }

  ngOnInit() { }
}
